import { render, staticRenderFns } from "./templatemanage.vue?vue&type=template&id=d409b408&scoped=true"
import script from "./templatemanage.vue?vue&type=script&lang=js"
export * from "./templatemanage.vue?vue&type=script&lang=js"
import style0 from "./templatemanage.vue?vue&type=style&index=0&id=d409b408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d409b408",
  null
  
)

export default component.exports